const makeOfferBtn = document.getElementById('make-offer-btn');
const makeOfferModal = document.querySelector('.make-offer-modal');
const closeOfferModal = document.getElementById('close-make-offer-modal');

makeOfferBtn?.addEventListener('click', () => {
  makeOfferModal.classList.remove('offerHideModal');
// console.log('clicked');

});

closeOfferModal?.addEventListener('click', () => {
  makeOfferModal.classList.add('offerHideModal');
});

makeOfferModal?.addEventListener('click', (e) => {
  if (e.target.classList.contains('make-offer-modal-overlay')) {
    makeOfferModal.classList.add('offerHideModal');
  }
});
